import { NextPage } from "next";
import Link from "next/link";
import Layout from "../../components/Layout";

const Documentation: NextPage = () => {
  return (
    <Layout currentPage="">
      <div className="flex w-full justify-center flex-row">
        <Link href="/documentation/videos">
          <button
            type="button"
            className="p-2.5 flex items-center bg-red rounded-lg text-white font-bold text-xs uppercase mt-5 mb-5"
          >
            Bekijk de video&apos;s
          </button>
        </Link>
      </div>

      <div className="flex min-h-[calc(100%-72px-76px)] w-full justify-center flex-row">
        <iframe
          className="w-[816px] drop-shadow-lg"
          src="https://docs.google.com/document/d/e/2PACX-1vQQSDnywuU2XWnwQghZsg7ZshDVdXH5cTyg8-DzIDM-W3B3saMG7r4iKLI4NRLTnKbN3kdB3g1MkOCk/pub?embedded=true"
        ></iframe>
      </div>
    </Layout>
  );
};

export default Documentation;
